import {inArray} from '@utils'

const validate = (value, {data: options}) => {
    if (Array.isArray(options)) {
        return !! options.filter(option => validate(value, {data: option})).length
    }

    return inArray(options, value);
}

export default validate
